import React from "react";
import { Tabs, Tab, Paper, useTheme, alpha } from "@mui/material";

const InkindTabs = ({ type, activeTab, setActiveTab, setPage }) => {
  const theme = useTheme();
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    if (setPage) setPage(0);
  };
  
  return (
    <Paper
      elevation={0}
      sx={{
        background: alpha(theme?.palette?.background?.paper || '#fff', 0.8),
        backdropFilter: "blur(8px)",
        borderRadius: "12px",
        overflow: "hidden",
        mb: 3,
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        sx={{
          "& .MuiTab-root": {
            fontWeight: "600",
            textTransform: "none",
            fontSize: "0.875rem",
          },
        }}
      >
        <Tab label="Overview" />
        <Tab label={`All In-Kind ${type === 'services' ? 'Services' : 'Offers'}`} />
        <Tab label="Active Donations" />
        <Tab label="Active Needs" />
      </Tabs>
    </Paper>
  );
};

export default InkindTabs;